'use client';

import * as React from 'react';
import {Card} from '../card/card';
import {getRybbitAnalyticsContent} from '../../lib/cookie-utils';

interface RybbitAnalyticsContentProps {
  locale?: 'en' | 'no' | 'sv' | 'da';
  className?: string;
}

export function RybbitAnalyticsContent({
  locale = 'no',
  className = ''
}: RybbitAnalyticsContentProps) {
  const content = getRybbitAnalyticsContent(locale);

  const sections = content.detailed.split('\n\n');

  return (
    <Card className={`p-6 ${className}`}>
      <div className="space-y-6">
        <div>
          <h3 className="mb-4 text-xl font-semibold">
            {locale === 'no'
              ? 'Rybbit Analytics'
              : locale === 'en'
                ? 'Rybbit Analytics'
                : locale === 'sv'
                  ? 'Rybbit Analytics'
                  : 'Rybbit Analytics'}
          </h3>
          <p className="text-muted-foreground mb-4 text-sm">{content.short}</p>
        </div>

        <div className="space-y-4">
          {sections.map((section, index) => {
            if (!section.trim()) return null;

            const lines = section.split('\n');
            const title = lines[0];
            const content = lines.slice(1);

            return (
              <div key={index} className="space-y-2">
                <h4 className="text-base font-medium">{title}</h4>
                <div className="text-muted-foreground space-y-1 text-sm">
                  {content.map((line, lineIndex) => {
                    if (line.startsWith('•')) {
                      return (
                        <div
                          key={lineIndex}
                          className="flex items-start space-x-2"
                        >
                          <span className="text-primary mt-1">•</span>
                          <span>{line.substring(1).trim()}</span>
                        </div>
                      );
                    }
                    return <p key={lineIndex}>{line}</p>;
                  })}
                </div>
              </div>
            );
          })}
        </div>

        <div className="border-t pt-4">
          <p className="text-muted-foreground text-xs">
            © 2025 Purpose IT AS.{' '}
            {locale === 'no'
              ? 'Alle rettigheter forbeholdt.'
              : locale === 'en'
                ? 'All rights reserved.'
                : locale === 'sv'
                  ? 'Alla rättigheter förbehållna.'
                  : 'Alle rettigheder forbeholdes.'}
          </p>
        </div>
      </div>
    </Card>
  );
}
